import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-light-svg-icons";

type Props = {
    value?: string;
    placeholder?: string;
    className?: string;
    onChange?: (value: string) => void;
};

const SearchBox = ({
    value = "",
    placeholder = "What are you looking for?",
    className,
    onChange = () => {},
}: Props) => {
    return (
        <div className={`c-searchbox ${className}`}>
            <input
                value={value}
                onChange={({ target }) => onChange(target.value)}
                className="c-searchbox__input"
                placeholder={placeholder}
            />
            <FontAwesomeIcon
                className="c-searchbox__magnifying-glass"
                icon={faSearch}
            />
        </div>
    );
};

export default SearchBox;
